<template lang="pug">
  <div>
    v-app-bar(
      v-if="!showToolbarAndNavDrawer"
      color="white"
    )

      img(
          class="mr-3" 
          :src="require('../assets/Logo-iMemo.png')" 
          height="40"
          @click="$router.push('/')" 
          style="cursor: pointer;"
        )
      v-toolbar-title(
        @click="$router.push('/')" 
        class="align-self-center" 
        style="cursor: pointer; font-size: 24px; font-weight: 600;"
      ) i-Memo

      v-spacer

      v-toolbar-title 
        span
          h5(style="font-weight: 400;") You already have an account?
            router-link(to="/login" class="pl-1" style="text-decoration: none; color: #D42A2A; font-weight: 600;") SIGN IN

  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SignupCard",
   computed: {
    showToolbarAndNavDrawer() {
      if (this.$route.path.match(/^\/page-approval/g)) return false;
      if (!this.$store.getters.isAuthenticated) return false;
      return true;
    },
  },
};
</script>
  